import CommonTable from '@components/CommonTable'
import CommonSearchForm from '@components/CommonSearchForm/CommonSearchForm'

/**
 * 全局组件注册
 */
function plugins(Vue) {
    Vue.component('common-table', CommonTable)
	 Vue.component('common-search-form', CommonSearchForm)
}

export default plugins